import { gql } from '@apollo/client';

export interface DataSubjectDetails {
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  countryCode?: string;
}
export interface Consent {
  name: 'Group Marketing Consent' | 'Data Sharing';
  consentStatus: 'CONFIRMED';
}

export interface UserConsentResponse {
  userConsent: string;
}

export const VIRGIN_COMMS_OPT = gql`
  mutation userConsent($consent: [Consent!]!, $dataSubjectDetails: DataSubjectDetails!) {
    userConsent(consent: $consent, dataSubjectDetails: $dataSubjectDetails)
  }
`;
